export default __webpack_public_path__ + "static/media/prize-5.b7fae7c5.webp";